module.exports = __webpack_public_path__ + "img/intro-main.27c203c4.gif";